<div class="container-fluid models-root m-0 p-0" appFitViewport [ngClass]="{'dark-theme': isDark}" style="overflow: hidden;">
    <!-- Panel flotante de control -->
    <div class="floating-control-panel" (mouseenter)="expandirDiv()" (mouseleave)="contraerDiv()" 
         [ngClass]="{'expanded': mouseSobreDiv}">
        <div class="panel-toggle">
            <mat-icon>{{mouseSobreDiv ? 'chevron_left' : 'menu'}}</mat-icon>
        </div>
        <div class="panel-content">
            <h6 class="panel-title mb-2">Paneles</h6>
            <div class="panel-option">
                <mat-checkbox [checked]="modeloDiv" (change)="showTab('modelo')" [color]="'primary'">
                    {{ esModoAnalisis ? 'Screener' : 'Modelo' }}
                </mat-checkbox>
            </div>
            <div class="panel-option" *ngIf="!esModoAnalisis">
                <mat-checkbox [checked]="cartera" (change)="showTab('cartera')" [color]="'primary'">
                    Cartera Óptima
                </mat-checkbox>
            </div>
            <div class="panel-option" *ngIf="esModoAnalisis">
                <mat-checkbox [checked]="listaCompaniaDiv" (change)="showTab('lista')" [color]="'primary'">
                    Compañías
                </mat-checkbox>
            </div>
        </div>
    </div>

    <div class="row-container p-0 m-0" #rowContainer>
        <div class="col-md-3 resizable-column p-0 m-0" *ngIf="modeloDiv" #column1 style="width: 20.83%">
            <div class="resize-handle" (mousedown)="startResizing($event, column1)"></div>

            <mat-card class="mb-25 enrolled-created-box ccorbit-card">
                <mat-card-content>
                    <mat-tab-group #tabsModelo class="modelo-tabs" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                        [(selectedIndex)]="tabModeloIdx"
                        (selectedTabChange)="onTab2Change($event)">

                        <!-- En modo análisis (/models?modo=analisis) no aplica: se abre directo en Screener. -->
                        <mat-tab *ngIf="!esModoAnalisis">
                            <ng-template mat-tab-label>
                                Crear Modelo
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('crearModelo', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-crear-modelo #crearModeloRef
                                [fechaInicial]="fechaInicial"
                                [fecharegistrosuscripcion]="fecharegistrosuscripcionurl"
                                [frecuencySelect]="frecuencySelect"
                                [selectedFrecuency]="selectedFrecuency"
                                [mercados]="mercados"
                                [restringirCuentaMetaapi]="true"
                                [selectedIdMercado]="selectedIdMercado"
                                [planificadorsv]="planificadorsv"
                                [companiasIndice]="companiasIndice"
                                [companiasVolatilidad]="companiasVolatilidad"
                                [idMercadoIndice]="idMercadoIndice"
                                [idActivoIndice]="idActivoIndice"
                                [idMercadovolatilidad]="idMercadovolatilidad"
                                [idActivoVolatilidad]="idActivoVolatilidad"
                                [bajista]="bajista"
                                [periodico]="periodico"
                                [todosSelected]="todosSelected"
                                [Modelformdata]="Modelformdata"
                                [optimalWallet]="optimalWallet"
                                [asignarCapital]="asignarCapital"
                                [repeticionEntradas]="repeticionEntradas"
                                [editing]="editing"
                                [stopLoss]="stopLoss"
                                [stopLossDinamico]="stopLossDinamico"
                                [stopLossValue]="stopLossValue"
                                [proFit]="proFit"
                                [proFitValue]="proFitValue"
                                [diasSalida]="diasSalida"
                                [diasSalidaValue]="diasSalidaValue"
                                [salidaFinDia]="salidaFinDia"
                                [isInValidModel]="isInValidModel"
                                [activatedModelo]="activatedModelo"
                                [earningsActive]="listaCompaniaDiv"
                                (changeInputEvent)="changeInput($event.field, $event.event)"
                                (toggleIndiceEvent)="toggleIndice()"
                                (toggleVolatilidadEvent)="toggleVolatilidad()"
                                (buscarCompaniaEvent)="buscarCompania($event)"
                                (registrarCompaniaEvent)="registrarCompania($event.type, $event.event)"
                                (onTodosChangeEvent)="onTodosChange($event)"
                                (actualizarcapitalinicialEvent)="actualizarcapitalinicial()"
                                (startEditingEvent)="startEditing($event)"
                                (finishEditingEvent)="finishEditing($event)"
                                (actualizarSlideStoplossEvent)="actualizarSlideStoploss($event)"
                                (actualizarSlideProfitEvent)="actualizarSlideProfit($event)"
                                (actualizarSlideDiasSalidaEvent)="actualizarSlideDiasSalida($event)"
                                (actualizarSlideStoplossDinamicoEvent)="actualizarSlideStoplossDinamico($event)"
                                (actualizarSlideSalidaFinDiaEvent)="actualizarSlideSalidaFinDia($event)"
                                (tipoEstrategiaChangeEvent)="onTipoEstrategiaChange($event)"
                                (generateModelEvent)="generateModel()"
                                (getFrecuencyEvent)="getFrecuency($event)">
                            </app-crear-modelo>
                        </mat-tab>

                        <mat-tab>
                            <ng-template mat-tab-label>
                                Buscador
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('buscador', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-buscador [context]="'modelo'" [selectedTab2]="selectedTab2"></app-buscador>
                        </mat-tab>

                        <!-- Screener: mismo panel y mismo motor de condiciones que Crear Modelo,
                             pero acotado a una fecha; el resultado se puede guardar como lista. -->
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Screener
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('screener', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-crear-modelo
                                [screener]="true"
                                [fechaInicial]="fechaInicial"
                                [frecuencySelect]="frecuencySelect"
                                [selectedFrecuency]="selectedFrecuency"
                                [mercados]="mercados"
                                [restringirCuentaMetaapi]="true"
                                [selectedIdMercado]="selectedIdMercado"
                                [planificadorsv]="planificadorsv"
                                [companiasIndice]="companiasIndice"
                                [companiasVolatilidad]="companiasVolatilidad"
                                [idMercadoIndice]="idMercadoIndice"
                                [idActivoIndice]="idActivoIndice"
                                [idMercadovolatilidad]="idMercadovolatilidad"
                                [idActivoVolatilidad]="idActivoVolatilidad"
                                [Modelformdata]="Modelformdata"
                                [optimalWallet]="optimalWallet"
                                [editing]="editing"
                                [isInValidModel]="isInValidModel"
                                [activatedModelo]="screenerBuscando"
                                (changeInputEvent)="changeInput($event.field, $event.event)"
                                (toggleIndiceEvent)="toggleIndice()"
                                (toggleVolatilidadEvent)="toggleVolatilidad()"
                                (buscarCompaniaEvent)="buscarCompania($event)"
                                (registrarCompaniaEvent)="registrarCompania($event.type, $event.event)"
                                (startEditingEvent)="startEditing($event)"
                                (finishEditingEvent)="finishEditing($event)"
                                (generateModelEvent)="buscarScreener()"
                                (getFrecuencyEvent)="getFrecuency($event)">
                            </app-crear-modelo>

                            <div class="param-row" *ngIf="esModoAnalisis">
                                <mat-slide-toggle #estadisticasToggleAnchor [(ngModel)]="estadisticasPanelOpen"
                                    (change)="estadisticasPanelOpen ? openEstadisticasPanel() : closeEstadisticasPanel()"
                                    [color]="'primary'">
                                    Estadísticas
                                </mat-slide-toggle>
                            </div>

                            <ng-template #estadisticasPanel>
                                <div class="periodico-section">
                                    <div class="oc-section-header estadisticas-panel-header">
                                        <mat-icon>analytics</mat-icon>
                                        <span>ESTADÍSTICAS</span>
                                        <button type="button" class="periodico-panel-close" (click)="closeEstadisticasPanel()" mat-icon-button>
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                    <div class="param-row">
                                        <mat-checkbox [color]="'primary'" [checked]="planificadorsv.condiciones.length > 0">
                                            Condiciones
                                        </mat-checkbox>
                                    </div>
                                    <div class="param-row" *ngIf="statsFormdata">
                                        <mat-checkbox [color]="'primary'" [checked]="statsFormdata.diadesemana" [disabled]="true">
                                            Día de la Semana {{diasemanaliteral}}
                                        </mat-checkbox>
                                    </div>
                                    <div class="param-row dias-semana-group" *ngIf="statsFormdata">
                                        <mat-checkbox *ngFor="let dia of diasSemanaOptions" [color]="'primary'"
                                            [checked]="statsFormdata.diaSemanaSeleccionado === dia.valor"
                                            (change)="onDiaSemanaChange(dia, $event.checked)" [matTooltip]="dia.nombre">
                                            {{dia.abrev}}
                                        </mat-checkbox>
                                    </div>

                                    <div class="param-row" *ngIf="statsFormdata">
                                        <mat-checkbox [color]="'primary'" [(ngModel)]="statsFormdata.diashabiles">
                                            Solo Días Hábiles
                                        </mat-checkbox>
                                    </div>
                                    <div class="param-row param-row-split" *ngIf="statsFormdata">
                                        <label class="param-label-group">Rango %: </label>
                                        <input type="number" class="listas param-input" [(ngModel)]="statsFormdata.rangoPorcentualEvaluar">
                                        <label class="param-label-group">Días : </label>
                                        <input type="number" class="listas param-input" [(ngModel)]="statsFormdata.diasEvaluar">
                                    </div>
                                    <button mat-flat-button class="ccorbit d-block fw-semibold generate-btn"
                                        [disabled]="activatedEstadisticas || !statsFormdata" (click)="funcionaEstadisticas()">
                                        <mat-icon class="me-1">analytics</mat-icon> Funciona Estadísticas
                                    </button>
                                    <div class="spinner-container" *ngIf="activatedEstadisticas">
                                        <mat-spinner diameter="60"></mat-spinner>
                                    </div>
                                </div>
                            </ng-template>

                            <div class="screener-results">
                                <div *ngIf="screenerBuscando" class="screener-loading">
                                    <mat-spinner diameter="24"></mat-spinner>
                                    <span>Buscando compañías que cumplen las condiciones...</span>
                                </div>

                                <ng-container *ngIf="!screenerBuscando && screenerBuscado">
                                    <div class="screener-header">
                                        <span class="screener-count">
                                            {{ screenerCompanias.length }} compañía(s) el {{ screenerFechaBuscada }}
                                        </span>
                                        <button class="screener-crear-lista" title="Crear lista"
                                                [disabled]="screenerCompanias.length === 0"
                                                (click)="crearListaScreener()">
                                            <mat-icon>playlist_add</mat-icon>
                                        </button>
                                    </div>

                                    <div *ngIf="screenerCompanias.length === 0" class="alert alert-info py-2 mb-0">
                                        Ninguna compañía del mercado cumple las condiciones en esa fecha.
                                    </div>

                                    <ul *ngIf="screenerCompanias.length > 0" class="screener-list">
                                        <li *ngFor="let c of screenerCompanias; let i = index">
                                            <span class="screener-index">{{ i + 1 }}</span>
                                            <a class="activo-link" [href]="urlMercadoScreener(c)" target="_blank">{{ c.nombreCompania }} <mat-icon>open_in_new</mat-icon></a>
                                        </li>
                                    </ul>
                                </ng-container>
                            </div>
                        </mat-tab>

                        <mat-tab label="+">

                        </mat-tab>
                        
                    </mat-tab-group>

                </mat-card-content>
            </mat-card>

        </div>

        <div class="col-md-2 p-0 m-0 resizable-column" [ngClass]="{'planificador': isPlanificador}"
            *ngIf="!esModoAnalisis && cartera" #column2 style="width: 15%">
            <div class="resize-handle" (mousedown)="startResizing($event, column2)"></div>
            <mat-card class="enrolled-created-box ccorbit-card oc-card">
                <mat-card-content class="oc-content">

                    <!-- ── CARTERA ÓPTIMA ─────────────────────────────── -->
                    <div class="oc-section-header">
                        <span>CARTERA ÓPTIMA</span>
                        <mat-icon class="oc-help-icon" (click)="showCarteraHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                    </div>

                    <div class="oc-grid">
                        <label class="oc-label">Capital Inicial</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.capitalinicial" (ngModelChange)="calcularData()">

                        <label class="oc-label">Valor Liquidativo</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.valorLiquidativo" disabled>

                        <label class="oc-label">Efectivo</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.efectivo" disabled
                            [ngClass]="{'input-error-letra': !efectivopositivo}">

                        <label class="oc-label">Tipo Cuenta</label>
                        <select class="oc-select" (change)="disabledMargin($event)" [(ngModel)]="optimalWallet.tipocuenta" (ngModelChange)="calcularData()">
                            <option selected>Seleccionar</option>
                            <option value="{{type}}" *ngFor="let type of accountType">{{type}}</option>
                        </select>

                        <label class="oc-label">Margen Requerido %</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.margenRequeridoPor" (ngModelChange)="calcularData()">

                        <label class="oc-label">Control Margin Call %</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.controlMarginCall" (ngModelChange)="calcularData()">

                        <label class="oc-label">Margen Total</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.margen" disabled
                            [ngClass]="{'input-error': !existeriesgo}">

                        <label class="oc-label">Fondos Disponibles</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.fondosDisponibles" disabled>

                        <label class="oc-label">Poder Adquisitivo</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.poderCompra" disabled>

                        <label class="oc-label">Apalancamiento</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.apalancamiento"
                            (ngModelChange)="calcularDataApalancamiento()" min="1" step="1">
                    </div>

                    <!-- ── CONFIGURACIÓN RIESGO ───────────────────────── -->
                    <div class="oc-section-header">
                        <span>CONFIGURACIÓN RIESGO</span>
                        <mat-icon class="oc-help-icon" (click)="showRiesgoHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                    </div>

                    <div class="oc-grid">
                        <label class="oc-label">Riesgo Máximo %</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.riesgomaximo" (ngModelChange)="calcularData()">

                        <label class="oc-label">Tipo Riesgo</label>
                        <select class="oc-select" [(ngModel)]="optimalWallet.tiporiesgo" (ngModelChange)="calcularData()">
                            <option selected>Selecciona</option>
                            <option value="{{type}}" *ngFor="let type of purchaseTypes">{{type}}</option>
                        </select>

                        <label class="oc-label">Valor Riesgo</label>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.riesgo" (ngModelChange)="calcularData()">

                        <div class="oc-check-label">
                            <mat-slide-toggle [(ngModel)]="optimalWallet.chkcomisionbroker" [color]="'primary'">
                                Comisión 2/2</mat-slide-toggle>
                        </div>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.comisionbroker" (ngModelChange)="calcularData()"
                            [disabled]="!optimalWallet.chkcomisionbroker">

                        <div class="oc-check-label">
                            <mat-slide-toggle [(ngModel)]="optimalWallet.chkgastogest" [color]="'primary'">
                                Gastos Gestión</mat-slide-toggle>
                        </div>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.gastosGestionPor" (ngModelChange)="calcularData()"
                            [disabled]="!optimalWallet.chkgastogest">

                        <div class="oc-check-label">
                            <mat-slide-toggle [(ngModel)]="optimalWallet.chkgastoprest" [color]="'primary'">
                                Gastos Préstamo %</mat-slide-toggle>
                        </div>
                        <input class="oc-input" type="number" [(ngModel)]="optimalWallet.gastosPrestamoPor" (ngModelChange)="calcularData()"
                            [disabled]="!optimalWallet.chkgastoprest">

                        <div class="oc-check-full">
                            <mat-slide-toggle [color]="'primary'" [checked]="optimalWallet.participacion"
                                (change)="participacion($event, 'participacion')" (ngModelChange)="calcularData()">
                                Comprar/Vender Fracciones</mat-slide-toggle>
                        </div>
                    </div>

                    <!-- ── ACCIONES ────────────────────────────────────── -->
                    <div class="oc-actions">
                        <button [disabled]="!activatedOptima" mat-flat-button (click)="walletAnalysis()" class="ccorbit oc-btn oc-btn--primary">
                            <mat-icon>analytics</mat-icon>Análisis Cartera Óptima</button>
                        <button [disabled]="!activatedOptima" mat-flat-button (click)="guardarPonderador(false)" class="ccorbit oc-btn" matTooltip="Portfolio Labs/Gestor">
                            <mat-icon>add_chart</mat-icon> Portfolio Labs
                        </button>
                        <button [disabled]="!activatedInforme" mat-flat-button (click)="guardarInforme()" class="ccorbit oc-btn" matTooltip="Automatización">
                            <mat-icon>save</mat-icon> Automatización 
                        </button>
                        <!--button [disabled]="!simularGest" mat-flat-button (click)="guardarPonderador(true)" class="ccorbit oc-btn" matTooltip="Simular en el Gestor">
                            <mat-icon>play_circle</mat-icon> Simular
                        </button-->
                        <button [disabled]="!simularGest" mat-flat-button (click)="enviarAStrategyFactory()" class="ccorbit oc-btn" matTooltip="Enviar a Strategy Factory">
                            <mat-icon>batch_prediction</mat-icon> Strategy Factory
                        </button>
                    </div>

                    <div *ngIf="isPlanificador">
                        <app-lista-modelo [isPlanificador]="isPlanificador" (cartera)="recalcularPonderador($event)">
                        </app-lista-modelo>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-md-2 p-0 m-0 resizable-column" style="width: 400px;"
            *ngIf="esModoAnalisis && listaCompaniaDiv" #columnLista>
            <div class="resize-handle" (mousedown)="startResizing($event, columnLista)"></div>
            <mat-card class="enrolled-created-box ccorbit-card oc-card">
                <mat-card-content class="oc-content">
                    <div class="oc-section-header">
                        <span>COMPAÑIAS</span>
                    </div>
                    <app-tabla-compania [fechaInicial]="fechaInicial"></app-tabla-compania>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col p-0 m-0 ">
            <mat-card class="mb-25 enrolled-created-box no-scrollbar ccorbit-card">
                <mat-card-content class=" ">
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                        [selectedIndex]="selectedTab" (selectedTabChange)="onTabChange($event)">
                        <mat-tab *ngIf="!listaCompaniaDiv">
                            <ng-template mat-tab-label>
                                Gestión/Contabilidad
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('gestion', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-planificador-gestion [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading" [habilitarGraficaEmbebida]="true">
                            </app-planificador-gestion>
                        </mat-tab>
                        <mat-tab *ngIf="!listaCompaniaDiv">
                            <ng-template mat-tab-label>
                                Operaciones
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('operaciones', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-operations [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading"></app-operations>
                        </mat-tab>
                        <mat-tab *ngIf="!listaCompaniaDiv">
                            <ng-template mat-tab-label>
                                Valores liquidativos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('valores', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-liquidating-values [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading"></app-liquidating-values>
                        </mat-tab>
                        <mat-tab *ngIf="!listaCompaniaDiv">
                            <ng-template mat-tab-label>
                                Rendimientos/Riesgos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('rendimientos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-rendimientoriesgo [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading"></app-rendimientoriesgo>
                        </mat-tab>
                        <mat-tab *ngIf="!listaCompaniaDiv">
                            <ng-template mat-tab-label>
                                Posiciones Cartera
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('cartera', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-cartera [selectedTab]="selectedTab" [modelo]="modelo" [isPlanificador]="isPlanificador"
                                [loading]="loading"></app-cartera>
                        </mat-tab>
                        <mat-tab *ngIf="listaCompaniaDiv">
                            <ng-template mat-tab-label>
                                Estadisticas
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('estadisticas', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <mat-card class="mb-25 enrolled-created-box ccorbit-card no-scrollbar">
                                <mat-card-content class="">
                                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
                                        <mat-tab>
                                            <ng-template mat-tab-label>
                                                Analisis Estadisticos
                                                <mat-icon class="tab-help-icon" (click)="showTabHelp('Analisis Estadísticos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                                            </ng-template>
                                            <app-analisis-estadistico [selectedTab]="selectedTab" [Modelformdata]="statsFormdata"></app-analisis-estadistico>
                                        </mat-tab>
                                        <mat-tab>
                                            <ng-template mat-tab-label>
                                                Analisis Periodos
                                                <mat-icon class="tab-help-icon" (click)="showTabHelp('Analisis Periodos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                                            </ng-template>
                                            <app-analisis-periodos [selectedTab]="selectedTab"
                                                (irAGrafica)="irAGraficaAnalisis()"></app-analisis-periodos>
                                        </mat-tab>
                                    </mat-tab-group>
                                </mat-card-content>
                            </mat-card>
                        </mat-tab>
                        <mat-tab *ngIf="listaCompaniaDiv">
                            <ng-template mat-tab-label>
                                Estudio Earning
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('earning', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-estudio-earning [selectedTab]="selectedTab"></app-estudio-earning>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Gráfica Análisis
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('graficaAnalisis', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-grafica-modelo [embedded]="true"></app-grafica-modelo>
                        </mat-tab>

                    </mat-tab-group>

                </mat-card-content>
            </mat-card>

        </div>

    </div>
</div>